module.exports = __webpack_public_path__ + "static/img/micro-location.b4bcfce8.svg";